import React, { useEffect, useState } from "react";
import * as Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import Equity from "../../../../../assets/images/equity_db_icon.svg";
import Commodity from "../../../../../assets/images/commodity_db_icon.svg";
import Currency from "../../../../../assets/images/currency_db_icon.svg";
import Derivatives from "../../../../../assets/images/derivatives_db_icon.svg";
import ColoumnsHeader from "../../generic/ColoumnsHeader";
import { convertRS, VolumeStateOptions } from "../../utlits";
import NoDataFound from "../../generic/NoDataFound";

const borderRadius = require("highcharts-border-radius");
borderRadius(Highcharts);

export interface IVSBarChartProps {
  rowStateData: any;
  dropdownValue: string | number;
  setDropdownValue: (value: string | number) => void;
}

const VSBarChart: React.FC<IVSBarChartProps> = (props) => {
  let HandelGraph = (value: any) => {
    return `<img  style="width: 40px; height: 40px; margin-top:5px" src=${value}></img>`;
  };

  const [ordVolState, setOrdVolState] = useState<any>([]);
  const [disableMenu, setDisableMenu] = useState<boolean>(false);

  const Icons: any = {
    Cash: Equity,
    Derivatives: Derivatives,
    Currency: Currency,
    Commodity: Commodity,
  };

  const handelOrdVolState = (data: any) => {
    let getDataFlow = data.map((ordVol: any) => {
      return {
        heading: ordVol.key === "Cash" ? "Equity" : ordVol.key,
        name: HandelGraph(Icons[ordVol.key]),
        y: parseInt(ordVol.val),
      };
    });
    setOrdVolState(getDataFlow);
  };

  useEffect(() => {
    if (props.rowStateData.length > 0) {
      setDisableMenu(false);
      handelOrdVolState(props.rowStateData);
    } else {
      setDisableMenu(true);
      setOrdVolState([]);
    }
  }, [props.rowStateData]);

  let options = {
    chart: {
      type: "bar",
      height: "300px",
      reversedStacks: false,
    },
    legend: "",
    credits: {
      enabled: false,
    },
    title: "",
    // exporting: {
    //   allowHTML: true,
    // },
    xAxis: {
      type: "category",
      labels: {
        useHTML: true,
      },
      title: "",
      lineColor: "transparent",
    },
    yAxis: {
      startOnTick: true,
      reversedStacks: false,
      title: null,
      left: 52,
      labels: {
        enabled: false,
      },

      gridLineColor: "transparent",
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        color: "#1c9ad60d",
        padding: "20px",
        borderRadiusTopLeft: 20,
        borderRadiusTopRight: 20,
        pointWidth: 40,
        dataLabels: {
          useHTML: true,
          align: "left",
          color: "black",
          width: "100%",
          style: {
            fontSize: "16px",
            padding: 0,
          },
          verticalAlign: "middle",
          enabled: true,
          inside: true,
          formatter: function (this: any): any {
            let result: any = convertRS(this.y, 2);
            return `<p><span style="color:#666;">₹</span> ${result}</p> <p style="font-size:11px; color:#666">${this.point.heading}</p>`;
          },
        },
      },
    },

    series: [
      {
        data: ordVolState.map((state: any) => {
          return state;
        }),
      },
    ],
  };

  return (
    <>
      <ColoumnsHeader
        title={"Stats"}
        isDropdown={true}
        isDownload={false}
        disableMenu={disableMenu}
        dropdownOptions={VolumeStateOptions}
        dropdownValue={props.dropdownValue}
        setDropdownValue={props.setDropdownValue}
      />
      {disableMenu ? (
        <NoDataFound />
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </>
  );
};

export default VSBarChart;
